import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

@Component({
  selector: 'app-personnal-infos',
  templateUrl: './personnal-infos.component.html',
  styleUrls: ['./personnal-infos.component.scss']
})
export class PersonnalInfosComponent implements OnInit {
  @Input() emailFromWS: String;
  @Output() emailBoolean = new EventEmitter<boolean>();
  @Output() emailInput = new EventEmitter<string>();

  maxLength = 60;
  emailFormControl: FormControl;
  emailRegex = new RegExp('^[a-zA-Z--9._%+-]+@[a-zA-Z-0-9.-]+\\.[a-za-zA-Z-]{2,4}$');
  userEmailForm: FormGroup;
  confirmValidParentMatcher = new ConfirmValidParentMatcher();
  isEmailInputValid : boolean;


  constructor(
    private formBuilder: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.emailValidCheck(this.emailFromWS.toLowerCase());
    this.createForm();
  }

  isMobile() {
    var width = window.outerWidth;

    if (width < 600) {
      return true
    }
    return false;
  }

  createForm() {
    this.userEmailForm = this.formBuilder.group({
      email: [this.emailFromWS, [
        Validators.required,
        Validators.pattern(this.emailRegex)
      ]]
    });
  }

  emailValidCheck(email) {
    if (this.emailRegex.test(email.toLowerCase())) {
      this.emailBoolean.emit(true);
      this.isEmailInputValid = true;
      this.emailInput.emit(email.toLowerCase());
    } else {
      this.emailBoolean.emit(false);
      this.isEmailInputValid = false;
    }
  }
}

/**
 * Custom ErrorStateMatcher which returns true (error exists) when the parent form group is invalid and the control has been touched
 */
 export class ConfirmValidParentMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {


    return !!(control && control.invalid);
  }
}